var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"owner-head"},[(_vm.kick)?_c('p',{staticClass:"owner-kick"},[_vm._v(_vm._s(_vm.kick))]):_vm._e(),_c('p',{staticClass:"owner-title"},[_vm._v(_vm._s(_vm.title))]),(_vm.sub)?_c('p',{staticClass:"owner-sub"},[_c('sentence-lines',{attrs:{"text":_vm.sub}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }